import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MdContact from './components/mdContact';
import ScContact from './components/scContact';
import ScInternalContact from './components/scInternalContact';
import reportWebVitals from './reportWebVitals';
import MdInternalContact from './components/mdInternalContact';
import WSI from './components/wsi/weeklySafetyInspections';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <WSI/> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
